export enum UuidErrors {
  INVALID_VERSION = "Invalid UUID value or version"
}

export interface UuidGenerator {
  validate(uuid: string);
  generate(): string;
}
